export const GAViewItemList = (products) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "view_item_list",
    ecommerce: {
      items: products
        .filter((p) => p.type !== "banner")
        .map((p, i) => {
          const itemCategory2 = p.metal ? { item_category2: p.metal } : {}
          const itemCategory3 = p.metal_color ? { item_category3: p.metal_color } : {}
          const itemCategory4 = p.product_collection ? { item_category4: p.product_collection } : {}
          return {
            item_name: p.name_without_brand,
            item_id: p.id,
            price: p.price,
            item_category: p.categories && p.categories.length ? p.categories[0].name : null,
            index: i + 1,
            quantity: 1,
            ...itemCategory2,
            ...itemCategory3,
            ...itemCategory4,
          }
        }),
    },
  });
};
